import { formatCurrency } from '@/utils/orderValue';

export const NET_EXPLANATION = 'After deducting source costs and delivery commission.';

export default function OrderNetValue({ result, onRetry }) {
  const status = result?.status;
  const text = status === 'ready' ? formatCurrency(result.net_cents / 100)
    : status === 'loading' ? '…' : status === 'not_configured' ? 'Not configured' : 'Unavailable';
  const context = status === 'not_configured' ? ' Set the driver cost in Shop Profile.'
    : result?.reason === 'offline_or_access' || result?.reason === 'local_order' ? ' Unavailable offline or without online access.'
    : result?.reason === 'order_changed' ? ' The saved order changed. Refresh the orders.'
    : status === 'ready' && !result.source_configured ? ' No per-order source deductions configured for this delivery date.' : '';
  return <span className="inline-flex max-w-full flex-wrap justify-end gap-x-1" data-testid="order-net-value"
    title={`${NET_EXPLANATION}${context}`} aria-label={`Net: ${text}.${context}`}>
    <span className="break-words">{text}</span>
    {status === 'unavailable' && onRetry && !['offline_or_access', 'local_order', 'order_changed'].includes(result?.reason)
      && <button type="button" className="text-xs underline" aria-label="Retry net calculation"
        onClick={event => { event.stopPropagation(); onRetry(); }}>Retry</button>}
  </span>;
}
